<template>
  <button
    type="button"
    data-testid="StudentGroupsButton-toggle"
    class="teacher-tool-btn"
    :class="{ selected: studentGroupsStore.modalOpen }"
    @click.stop="toggle"
  >
    <v-icon class="teacher-tool-icon">fa-light fa-user-group</v-icon>
    <span class="teacher-tool-label">Grupēt</span>
  </button>
</template>

<script lang="ts">
import { useAnnotationStore } from "~/stores/annotationStore"
import { useStickyBoardStore } from "~/stores/stickyBoardStore"
import { useStudentGroupsStore } from "~/stores/studentGroupsStore"
import { useStudentWheelStore } from "~/stores/studentWheelStore"
import { useTeacherTimerStore } from "~/stores/teacherTimerStore"

export default {
  setup() {
    const annotationStore = useAnnotationStore()
    const stickyBoardStore = useStickyBoardStore()
    const studentGroupsStore = useStudentGroupsStore()
    const studentWheelStore = useStudentWheelStore()
    const timerStore = useTeacherTimerStore()
    return { annotationStore, stickyBoardStore, studentGroupsStore, studentWheelStore, timerStore }
  },

  methods: {
    toggle() {
      const opening = !this.studentGroupsStore.modalOpen
      if (opening) {
        if (this.annotationStore.annotationMode && this.annotationStore.isGlobal) {
          this.annotationStore.toggleAnnotationMode()
        }
        this.studentWheelStore.setModalOpen(false)
        this.stickyBoardStore.setOpen(false)
        this.timerStore.yieldToOtherTool()
      }
      this.studentGroupsStore.setModalOpen(opening)
    },
  },
}
</script>
